const ADDRESS_SELECT_DROPDOWN_CLICKED = 'Address Select Dropdown Has Been Clicked';
const ADDRESS_SELECT_DROPDOWN_VISIBLE = 'Address Select Dropdown is Visible';
const CHANGED_CHART_TYPE = 'Changed Chart Type';
const CLOSED_BILL_VIEW = 'Closed Bill View';
const CLOSED_DOCUMENT_VIEW = 'Closed Document View';
const CLOSED_RATING_MODAL = 'Closed Rating Modal';
const CLOSED_SCE_TERMS_AND_CONDITIONS_MODAL = 'Closed SCE Enrollment Terms and Conditions Modal';
const CLOSED_SDGE_TERMS_AND_CONDITIONS_MODAL = 'Closed SDGE Enrollment Terms and Conditions Modal';
const CONDITIONS_NOT_MET_ON_CONDITIONAL_ROUTE = "Can't Find Page - Conditions Not Met on Conditional Route";
const DISABLED_EXPECTED_PRODUCTION = 'Disabled Expected Production';
const DISMISSED_CHART_TOUR = 'Dismissed Chart Tour';
const DOWNLOADED_DOCUMENT = 'Downloaded document';
const DOWNLOADED_DOCUMENT_MOBILE = 'Downloaded document - Mobile';
const FAILED_DATA_RETRIEVAL = 'Failed Data Retrieval';
const FAILED_FORM_SUBMISSION = 'Failed Form Submission';
const FAILED_PAYMENT_ATTEMPT = 'Failed Payment Attempt';
const FINISHED_CHART_TOUR = 'Closed Chart Tour';
const FOLLOWED_AUTOPAY_CTA = 'Followed Autopay CTA';
const FOLLOWED_BILLING_HISTORY_CTA = 'Followed Billing History CTA';
const FOLLOWED_CASES_LINK = 'Followed Cases Link';
const FOLLOWED_CONTACT_US_LINK = 'Followed Contact Us Link';
const FOLLOWED_CONTENT_LINK = 'Followed Content Link';
const FOLLOWED_DOCUMENTS_LINK = 'Followed Documents Link';
const FOLLOWED_METER_REPLACEMENT_BANNER = 'Followed Link to Meter Replacement Page from Banner Link';
const FOLLOWED_ORANGE_BILLING_PAYMENT = 'Followed Orange Post PTO Billing Link';
const FOLLOWED_SCE_TERMS_AND_CONDITIONS = 'SCE Enrollment - Followed Link to read T&C';
const FOLLOWED_SDGE_TERMS_AND_CONDITIONS = 'SDGE Enrollment - Followed Link to read T&C';
const FOLLOWED_SERVICE_TRANSFER_LINK = 'Followed service transfer link';
const FOLLOWED_SUPPORT_CTA = 'Followed Support CTA';
const FOLLOWED_SYSTEM_STATUS_LINK = 'Followed System Status Link';
const FOLLOWED_TOS_LINK = 'Followed Terms of Service Link';
const FOLLOWING_MONITORING = 'Following Monitoring CTA';
const LEFT_FAQ_FEEDBACK = 'Left Feedback for FAQ Question (y/n) on FAQ Page';
const LEFT_FAQ_FEEDBACK_EBCE_ENROLLMENT = 'Left Feedback for FAQ Question on EBCE Enrollment Page';
const LEFT_FAQ_FEEDBACK_METER_REPLACEMENT_INFORMATION = 'Left Feedback for FAQ Question on Meter Replacement Information Page';
const LEFT_FAQ_FEEDBACK_RTU_METER_REPLACEMENT_INFORMATION = 'Left Feedback for FAQ Question on RTU Meter Replacement Information Page';
const LEFT_FAQ_FEEDBACK_SCE_ENROLLMENT = 'Left Feedback for FAQ Question on SCE Enrollment Page';
const LEFT_FAQ_FEEDBACK_SDGE_ENROLLMENT = 'Left Feedback for FAQ Question on SDGE Enrollment Page';
const LEFT_FAQ_FEEDBACK_GS_ENROLLMENT = 'Left Feedback for FAQ Question on GS Confirmation Page';
const LEFT_FAQ_FEEDBACK_EV_SUPPORT = 'Left Feedback for FAQ Question on EV Support Page';
const LEFT_STAR_RATING = 'Left Star Rating';
const RETRIEVED_FILTERED_DOCUMENTS = 'Retrieved and filtered documents';
const REWATCH_GRAPH_TOUR = 'Relaunched Advanced Chart Tour';
const ROUTE_AFTER_LOGIN = 'After login user routed to:';
const SENT_REFERRAL_LEAD = 'Sent Referral Lead';
const SHOWN_CREATE_PAYMENT_ERROR = 'Shown Create Payment Error';
const SHOWN_SYSTEM_STATUS = 'System Status Displayed';
const STARTED_CHART_TOUR = 'Started Chart Tour';
const SUBMITTED_DIGITAL_SIGNATURE_SCE = 'SCE Enrollment Submitted Digital Signature';
const SUBMITTED_DIGITAL_SIGNATURE_SDGE = 'SDGE Enrollment Submitted Digital Signature';
const SUBMITTED_FEEDBACK_FORM = 'Submitted Feedback Form';
const SUCCESSFUL_PAYMENT_ATTEMPT = 'Payment Succeeded';
const UPDATE_PROSPECT_WITH_LEAP_AUTH = 'Called Update Prospect Dynamo with Leap Auth Number';
const VIEWED_BILL = 'Viewed bill';
const VIEWED_DOCUMENT = 'Viewed document';
const VIEWED_EXPECTED_PRODUCTION = 'Viewed Expected Production';
const VIEWED_FAQ_CATEGRORY = 'Viewed FAQ Category';
const VIEWED_FAQ_LINK = 'Viewed FAQ Link';
const VIEWED_FAQ_QUESTION = 'Viewed FAQ Question';
const VIEWED_FAQ_QUESTION_EBCE_ENROLLMENT = 'Viewed FAQ Question EBCE RA Enrollment';
const VIEWED_FAQ_QUESTION_METER_REPLACEMENT_INFORMATION = 'Viewed FAQ Question Meter Replacement Information Page';
const VIEWED_FAQ_QUESTION_RTU_METER_REPLACEMENT_INFORMATION = 'Viewed FAQ Question RTU Meter Replacement Information Page';
const VIEWED_FAQ_QUESTION_SCE_ENROLLMENT = 'Viewed FAQ Question SCE Enrollment';
const VIEWED_FAQ_QUESTION_SDGE_ENROLLMENT = 'Viewed FAQ Question SDGE Enrollment';
const VIEWED_FAQ_QUESTION_GS_ENROLLMENT = 'Viewed FAQ Question GS Enrollment';
const VIEWED_FAQ_QUESTION_EV_SUPPORT = 'Viewed FAQ Question EV Support';
const VIEWED_GRAPH_VIEW = 'Viewed Graph View';
const VIEWED_ONBOARDING_STEP = 'Viewed Onboarding Step';
const VISITED_FEEDBACK_PAGE = 'Visited Feedback Page';
const VISITED_EBCE_RA_ENROLLMENT_PAGE = 'Visited EBCE Enrollment Page';
const VISITED_EBCE_RA_CONFIRMATION_PAGE = 'Visited EBCE Confirmation Page';
const VISITED_GS_CONFIRMATION_PAGE_LEAP_THANKS = 'Visited Generic GS /leap/thanks Confirmation Page';
const VISITED_REFERRAL_PAGE = 'Visited Referral Page';
const VISITED_SCE_ENROLLMENT_PAGE = 'Visited SCE Enrollment Page';
const VISITED_SCE_CONFIRMATION_PAGE = 'Visited SCE Confirmation Page';
const VISITED_SDGE_PAGE = 'Visited SDG&E Enrollment Page';
const VISITED_SDGE_CONFIRMATION_PAGE = 'Visited SDG&E Confirmation Page';
const VISITED_STAR_RATING_PAGE = 'Visited Star Rating Page';

const VIEWED_PAGE = pageName => `Viewed ${pageName} Page`;

export {
  ADDRESS_SELECT_DROPDOWN_CLICKED,
  ADDRESS_SELECT_DROPDOWN_VISIBLE,
  CHANGED_CHART_TYPE,
  CLOSED_BILL_VIEW,
  CLOSED_DOCUMENT_VIEW,
  CLOSED_RATING_MODAL,
  CLOSED_SCE_TERMS_AND_CONDITIONS_MODAL,
  CLOSED_SDGE_TERMS_AND_CONDITIONS_MODAL,
  CONDITIONS_NOT_MET_ON_CONDITIONAL_ROUTE,
  DISABLED_EXPECTED_PRODUCTION,
  DISMISSED_CHART_TOUR,
  DOWNLOADED_DOCUMENT_MOBILE,
  DOWNLOADED_DOCUMENT,
  FAILED_DATA_RETRIEVAL,
  FAILED_FORM_SUBMISSION,
  FAILED_PAYMENT_ATTEMPT,
  FINISHED_CHART_TOUR,
  FOLLOWED_AUTOPAY_CTA,
  FOLLOWED_BILLING_HISTORY_CTA,
  FOLLOWED_CASES_LINK,
  FOLLOWED_CONTACT_US_LINK,
  FOLLOWED_CONTENT_LINK,
  FOLLOWED_DOCUMENTS_LINK,
  FOLLOWED_METER_REPLACEMENT_BANNER,
  FOLLOWED_ORANGE_BILLING_PAYMENT,
  FOLLOWED_SCE_TERMS_AND_CONDITIONS,
  FOLLOWED_SDGE_TERMS_AND_CONDITIONS,
  FOLLOWED_SERVICE_TRANSFER_LINK,
  FOLLOWED_SUPPORT_CTA,
  FOLLOWED_SYSTEM_STATUS_LINK,
  FOLLOWED_TOS_LINK,
  FOLLOWING_MONITORING,
  LEFT_FAQ_FEEDBACK_EBCE_ENROLLMENT,
  LEFT_FAQ_FEEDBACK_METER_REPLACEMENT_INFORMATION,
  LEFT_FAQ_FEEDBACK_RTU_METER_REPLACEMENT_INFORMATION,
  LEFT_FAQ_FEEDBACK_SCE_ENROLLMENT,
  LEFT_FAQ_FEEDBACK_SDGE_ENROLLMENT,
  LEFT_FAQ_FEEDBACK_GS_ENROLLMENT,
  LEFT_FAQ_FEEDBACK,
  LEFT_STAR_RATING,
  RETRIEVED_FILTERED_DOCUMENTS,
  REWATCH_GRAPH_TOUR,
  ROUTE_AFTER_LOGIN,
  SENT_REFERRAL_LEAD,
  SHOWN_CREATE_PAYMENT_ERROR,
  SHOWN_SYSTEM_STATUS,
  STARTED_CHART_TOUR,
  SUBMITTED_DIGITAL_SIGNATURE_SCE,
  SUBMITTED_DIGITAL_SIGNATURE_SDGE,
  SUBMITTED_FEEDBACK_FORM,
  SUCCESSFUL_PAYMENT_ATTEMPT,
  UPDATE_PROSPECT_WITH_LEAP_AUTH,
  VIEWED_BILL,
  VIEWED_DOCUMENT,
  VIEWED_EXPECTED_PRODUCTION,
  VIEWED_FAQ_CATEGRORY,
  VIEWED_FAQ_LINK,
  VIEWED_FAQ_QUESTION_EBCE_ENROLLMENT,
  VIEWED_FAQ_QUESTION_METER_REPLACEMENT_INFORMATION,
  VIEWED_FAQ_QUESTION_RTU_METER_REPLACEMENT_INFORMATION,
  VIEWED_FAQ_QUESTION_SCE_ENROLLMENT,
  VIEWED_FAQ_QUESTION_SDGE_ENROLLMENT,
  VIEWED_FAQ_QUESTION_GS_ENROLLMENT,
  VIEWED_FAQ_QUESTION,
  VIEWED_GRAPH_VIEW,
  VIEWED_ONBOARDING_STEP,
  VIEWED_PAGE,
  VISITED_EBCE_RA_ENROLLMENT_PAGE,
  VISITED_EBCE_RA_CONFIRMATION_PAGE,
  VISITED_FEEDBACK_PAGE,
  VISITED_GS_CONFIRMATION_PAGE_LEAP_THANKS,
  VISITED_REFERRAL_PAGE,
  VISITED_SCE_ENROLLMENT_PAGE,
  VISITED_SCE_CONFIRMATION_PAGE,
  VISITED_SDGE_PAGE,
  VISITED_SDGE_CONFIRMATION_PAGE,
  VISITED_STAR_RATING_PAGE,
  LEFT_FAQ_FEEDBACK_EV_SUPPORT,
  VIEWED_FAQ_QUESTION_EV_SUPPORT,
};
